import ConfigurationState from '../../../models/store/modules/configuration-state.model';
import Locale from '../../../models/utilities/locale.model';

import { TranslationService } from '../../../services/translation.service';
import SharedNotificationsConfig from '../../../models/entities/shared-notifications-config';
import { TrackingSplitters } from '../../../models/entities/tracking.model';

export const mutations = {
  direction(state: ConfigurationState, payload: string): void {
    state.direction = payload;
  },
  locale(state: ConfigurationState, payload: Locale): void {
    state.locale = payload;
  },
  market(state: ConfigurationState, payload: string): void {
    state.market = payload;
  },
  labels(state: ConfigurationState, payload: any): void {
    const labels = Object.assign({}, state.labels, payload);
    TranslationService.loadLocale(state.locale.language, payload);
    state.labels = labels;
  },
  links(state: ConfigurationState, payload: any): void {
    state.links = payload;
  },
  bookingActive(state: ConfigurationState, payload: boolean): void {
    state.bookingActive = payload;
  },
  rescheduleActive(state: ConfigurationState, payload: boolean): void {
    state.rescheduleActive = payload;
  },
  aemFormsResources(state: ConfigurationState, payload: string): void {
    state.aemFormsResources = payload;
  },
  aemFormsHandlerConfig(state: ConfigurationState, payload: string): void {
    state.aemFormsHandlerConfig = payload;
  },
  pickMeUpFromHome(state: ConfigurationState, payload: any): void {
    state.pickMeUpFromHome = payload;
  },
  cancellationFormConfig(state: ConfigurationState, payload: any): void {
    state.cancellationFormConfig = payload;
  },
  dealerRadius(state: ConfigurationState, payload: any): void {
    state.dealerRadius = payload;
  },
  dealerRadiusArray(state: ConfigurationState, payload: string[]): void {
    state.dealerRadiusArray = payload;
  },
  initialUnavailableDays(state: ConfigurationState, payload: number): void {
    state.initialUnavailableDays = payload;
  },
  dayTimePeriods(state: ConfigurationState, payload: any): void {
    state.dayTimePeriods = payload;
  },
  calendarWeekDayStart(state: ConfigurationState, payload: any): void {
    state.calendarWeekDayStart = payload;
  },
  calendarStartDate(state: ConfigurationState, payload: any): void {
    state.calendarStartDate = payload;
  },
  selectedDay(state: ConfigurationState, payload: any): void {
    state.selectedDay = payload;
  },
  dealerSearch(state: ConfigurationState, payload: any): void {
    state.dealerSearch = payload;
  },
  teaserVisible(state: ConfigurationState, payload: boolean): void {
    state.teaserVisible = payload;
  },
  formConfig(state: ConfigurationState, payload: any): void {
    state.formConfig = payload;
  },
  oneDoc(state: ConfigurationState, payload: any): void {
    state.oneDoc = payload;
  },
  context(state: ConfigurationState, payload: string): void {
    state.context = payload;
  },
  modelSeriesMapper(state: ConfigurationState, payload: any): void {
    state.modelSeriesMapper = payload;
  },
  modelMapping(state: ConfigurationState, payload: any): void {
    state.modelMapping = payload;
  },
  searchProfileName(state: ConfigurationState, payload: any): void {
    state.searchProfileName = payload;
  },
  footNotes(state: ConfigurationState, payload: any): void {
    state.footNotes = payload;
  },
  shouldSkipNoResultsPage(state: ConfigurationState, payload: boolean): void {
    state.shouldSkipNoResultsPage = payload;
  },
  sharedNotifications(
    state: ConfigurationState,
    payload: SharedNotificationsConfig
  ): void {
    state.sharedNotifications = payload;
  },
  isStandalone(state: ConfigurationState, payload: boolean): void {
    state.isStandalone = payload;
  },
  isCo2EmissionAndFuelConsumptionVisibile(
    state: ConfigurationState,
    payload: boolean
  ): void {
    state.isCo2EmissionAndFuelConsumptionVisibile = payload;
  },
  isEnergyEfficiencyVisibile(
    state: ConfigurationState,
    payload: boolean
  ): void {
    state.isEnergyEfficiencyVisibile = payload;
  },
  trackingSplitters(
    state: ConfigurationState,
    payload: TrackingSplitters
  ): void {
    state.trackingSplitters = payload;
  },
  utmParameters(state: ConfigurationState, payload: string): void {
    state.utmParameters = payload;
  },
};
